import { createSlice } from "@reduxjs/toolkit";
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import BadgeIcon from '@mui/icons-material/Badge';
import SettingsIcon from '@mui/icons-material/Settings';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import BallotIcon from '@mui/icons-material/Ballot';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import LaptopWindowsIcon from '@mui/icons-material/LaptopWindows';
import TimelineIcon from '@mui/icons-material/Timeline';
import GroupIcon from '@mui/icons-material/Group';
import PolicyIcon from '@mui/icons-material/Policy';
import LinkIcon from '@mui/icons-material/Link';
import SensorsIcon from '@mui/icons-material/Sensors';
import UpdateIcon from '@mui/icons-material/Update';
import DevicesIcon from '@mui/icons-material/Devices';
import AssignmentIcon from '@mui/icons-material/Assignment';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import VisibilityIcon from '@mui/icons-material/Visibility';

const organizationSlice = createSlice({
    name: 'organization',
    initialState: [ 
        {
            id: 'hospital' ,
            Label: 'Hospital',
            options: [
                {
                    id: 'dashboard',
                
                    Label: 'Modules',
                    icon: <DashboardCustomizeIcon />,
                    to: '/home',
                    menu: [
                        {
                           
                        id: 'Dashboard',
                        Label: 'Dashboard',
                        icon: <TimelineIcon />,
                        to: '/home',
                        },
                     
                    ]
                },
              
            {
                id: 'Browser Control',
                Label: 'Browser Control',
                icon: <BadgeIcon />,
               
                menu: [
                    // {
                    //     id: 'Users',
                    //     Label: 'Users',
                    //     to: '/user-management'
                    // },
                    // {
                    //     id: 'Roles',
                    //     Label: 'Roles',
                    //     to: '/roles'
                    // },
                    {
                        id: 'Groups',
                        Label: 'Groups',
                        icon: <GroupIcon />,
                        to: '/groups'
                    },
                    {
                        id: 'Policies',
                        Label: 'Policies',
                        icon: <PolicyIcon />,
                        to: '/policies'
                    },
                    {
                        id: 'Whitelist Urls',
                        Label: 'Whitelist Urls',
                        icon: <LinkIcon />,
                        to: '/urls'
                    },
                    {
                        id: 'Active Sessions',
                        Label: 'Active Sessions',
                        icon: <SensorsIcon />,
                        to: '/active-sessions'
                    },
                    {
                        id: 'Browser Updates',
                        Label: 'Browser Updates',
                        icon: <UpdateIcon />,
                        to: '/browser-updates'
                    },
                    {
                        id: 'Devices',
                        Label: 'Devices',
                        icon: <DevicesIcon />,
                        to: '/devices'
                    },
                    {
                        id: 'Questionnaire',
                        Label: 'Questionnaire',
                        icon: <AssignmentIcon />,
                        to: '/questionnaire'
                    },
            ],
        },
    //     {
    //         id: 'Patches',
    //         Label: 'Patches',
    //         icon: <LaptopWindowsIcon />,
           
    //         menu: [
    //             {
    //                 id: 'Assets',
    //                 Label: 'Assets',
    //                 to: '/asset'
    //             },
    //             {
    //                 id: 'Bulk-Import',
    //                 Label: 'Bulk-Import',
    //                 to: '/bulk-import'
    //             },

    //     ],
    // },
        {
            id: 'Insight Builder',
            Label: 'Insight Builder',
            icon: <CoPresentIcon />,
           
            menu: [
                     {
                        id: 'More Charts',
                        Label: 'More Charts',
                        icon: <InsertChartIcon />,
                        to: '/custom-charts'
                    },
              
            

        ],
    },
//     {
//         id: 'Notifications',
//         Label: 'Notifications',
//         icon: <CircleNotificationsIcon />,
       
//         menu: [
 
//             {
//                 id: 'Email Notification',
//                 Label: 'Email Notification',
//                 to: '/email-scheduler'
//             },
//             {
//                 id: 'All Notification',
//                 Label: 'All Notification',
//                 to: '/notifications'
//             },

//     ],
// },
{
    id: 'User Settings',
    Label: 'User Settings',
    icon: <SupervisorAccountIcon />,
   
    menu: [
        {
            id: 'Role',
            Label: 'Role',
            icon: <VerifiedUserIcon />,
            to: '/role'
        },
        {
            id: 'User Management',
            Label: 'User Management',
            icon: <ManageAccountsIcon />,
            to: '/user-management'
        },
],
},
            ],




        }
    ]
});

export default organizationSlice.reducer